import { Button, Layout, Row, Col } from 'antd';
import { Link } from 'react-router-dom';
const { Content} = Layout;

function errorPage(){
    return(
        <Content>
                <Row>
      <Col span={12} offset={9} style={{marginTop: "100px"}}>
      <iframe title="Simon Working" src="https://giphy.com/embed/zBOqRPmkEF3Ow" 
        width="480" height="330" frameBorder="">
        </iframe>
      </Col>
      <Col span={12} offset={6} style={{marginTop: "20px"}}>
      <h1>Whoops! Simon must have forgotten this page</h1>
      </Col>
      <Col span={12} offset={10}>
      <h2>404! Page not found</h2>
      </Col>
      <Col span={12} offset={11}>
      <Link to={'/'}>
        <Button type="primary" style={{marginTop: "40px"}}>Back Home</Button>
      </Link>
      </Col>
    </Row>
        </Content>
    )
}
export default errorPage